import { render, staticRenderFns } from "./PwdLessLogin.vue?vue&type=template&id=72c3bbcb&scoped=true"
import script from "./PwdLessLogin.vue?vue&type=script&lang=js"
export * from "./PwdLessLogin.vue?vue&type=script&lang=js"
import style0 from "./PwdLessLogin.vue?vue&type=style&index=0&id=72c3bbcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3bbcb",
  null
  
)

export default component.exports